import { useState } from 'react';

const useDropDown = ({ jobTitle = [] }) => {
  const [search, setSearch] = useState('');

  const jobTitleFilters = jobTitle.filter(field => {
    const isMatch = field[0]?.toLowerCase().startsWith(search.toLowerCase());
    if (isMatch) {
      return field;
    }
    return null;
  });

  return {
    setSearch,
    jobTitleFilters,
  };
};

export default useDropDown;
